import React, { ReactNode } from 'react';
import { Field, HelperMessage } from '@atlaskit/form';
import { MessageValue } from 'react-intl';
import Textfield from '@atlaskit/textfield';
import {
  FormLabel,
  LabelWrapper,
  LookRowContainer,
  RequiredAsterisk,
  TextfieldWrapper,
} from './styledComponents';

type OrderLookupFieldProps = {
  fieldName: string;
  fieldLabel?: MessageValue | ReactNode;
  helperLabel?: MessageValue | ReactNode;
  value?: string;
  changeHandler: (e: any) => void;
  lengthLimit?: number;
  dataCy?: string;
  width?: number;
  type?: string;
};

const OrderLookupField = ({
  fieldName,
  fieldLabel,
  helperLabel,
  value,
  lengthLimit,
  changeHandler,
  dataCy,
  width,
  type,
}: OrderLookupFieldProps) => (
  <LookRowContainer>
    <LabelWrapper>
      <FormLabel htmlFor={fieldName}>
        {fieldLabel as ReactNode}
        <RequiredAsterisk>*</RequiredAsterisk>
      </FormLabel>
    </LabelWrapper>
    <TextfieldWrapper>
      <Field
        aria-required="true"
        isRequired
        name={fieldName}
        id={fieldName}
        // label={fieldLabel as ReactNode}
      >
        {({ fieldProps }) => (
          <>
            <Textfield
              {...fieldProps}
              value={value}
              maxLength={lengthLimit}
              onChange={changeHandler}
              data-cy={dataCy}
              width={width}
              type={type}
            />

            {helperLabel && <HelperMessage>{helperLabel as ReactNode}</HelperMessage>}
          </>
        )}
      </Field>
    </TextfieldWrapper>
  </LookRowContainer>
);

export default OrderLookupField;
